var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3896 10.9449V8.94495C17.3896 6.18352 15.1511 3.94495 12.3896 3.94495C9.62822 3.94495 7.38965 6.18352 7.38965 8.94495V10.9449M12.3896 15.4449V17.4449M9.18965 21.9449H15.5896C17.2698 21.9449 18.1099 21.9449 18.7516 21.618C19.3161 21.3303 19.775 20.8714 20.0627 20.3069C20.3896 19.6652 20.3896 18.8251 20.3896 17.1449V15.7449C20.3896 14.0648 20.3896 13.2247 20.0627 12.583C19.775 12.0185 19.3161 11.5595 18.7516 11.2719C18.1099 10.9449 17.2698 10.9449 15.5896 10.9449H9.18965C7.50949 10.9449 6.66941 10.9449 6.02768 11.2719C5.46319 11.5595 5.00425 12.0185 4.71663 12.583C4.38965 13.2247 4.38965 14.0648 4.38965 15.7449V17.1449C4.38965 18.8251 4.38965 19.6652 4.71663 20.3069C5.00425 20.8714 5.46319 21.3303 6.02768 21.618C6.66941 21.9449 7.50949 21.9449 9.18965 21.9449Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock01);
export default __webpack_public_path__ + "static/media/lock-01.eafbb960f469f6b9b7fe70286bb24ee7.svg";
export { ForwardRef as ReactComponent };